<template>
  <main class="interview">
    <img class="close_icon" src="@/assets/close.svg" v-on:click="onClose()" />
    <transition name="vif">
      <div class="interview_contents" v-if="page.isProgress == false">
        <div class="interview_contents__left" v-if="diagnosisStatus < 2">
          <div class="qa qa--top">
            <div class="qa__question">
              <div class="qa__question_icon">Q1</div>
              <div class="qa__question_title" v-on:click="pager.toggleDebug()">
                最もやりたいことをおしえてください
              </div>
            </div>
            <div class="qa__answer">
              <div class="qa__answer_icon">A1</div>
              <div class="qa__answer_title">
                {{ getFirstAnswer() }}
              </div>
            </div>
          </div>

          <template v-for="(item, index) in page.qa?.getHistory()" :key="index">
            <div class="qa" v-if="index != 0" v-on:click="item.getPhase() != 'entry'
              ? qadelete(item.getId())
              : entrydelete(item.getId())
              " style="cursor: pointer">
              <div class="qa__question">
                <div class="qa__question_icon">Q{{ item.getStep() }}</div>
                <div class="qa__question_title" v-if="item.getPhase() == 'entry'">
                  「{{ item.getTitle() }}」で他にやりたいことは？
                </div>
                <div class="qa__question_title" v-if="item.getPhase() != 'entry'">
                  {{ item.getTitle() }}
                </div>
              </div>
              <div class="qa__answer">
                <div class="qa__answer_icon">A{{ item.getStep() }}</div>
                <div class="qa__answer_title">
                  {{ makeAnswerStringByHistory(item) }}
                  <div v-if="makeAnswerStringByHistory(item).length == 0">スキップ</div>
                </div>
              </div>
            </div>
          </template>
          <div class="qa">
            <div class="qa__question">
              <div class="qa__question_icon qa__question_icon--active">
                Q{{ page?.qa?.getQuestionNumber() }}
              </div>
              <div class="qa__question_title">
                {{ page?.qa?.getQuestionTitle()
                }}<span v-if="page.qa?.isMultiSelect()">（複数選択可）</span>
              </div>
            </div>
            <div class="qa__answer">
              <div class="qa__answer_icon" v-if="false">A1</div>
              <div class="qa__answer_title qa__answer_title--active">回答中</div>
            </div>
          </div>
        </div>
        <div class="interview_contents__main">
          <div class="interview_header">
            <div class="interview_header__progress">
              <div class="interview_header__no">
                <div class="interview_header__no_title">
                  <img class="interview_header__no_title_icon" src="@/assets/format_list_bulleted.svg" width="24" />回答
                </div>
                <div class="interview_header__no_num" v-show="page?.qa?.getQuestionNumber()">
                  Q{{ page?.qa?.getQuestionNumber() }}
                </div>
                <div v-if="false" style="margin-left: 16px; color: #636464">
                  あと最大<span style="
                      color: #ff6b4a;
                      font-weight: bold;
                      padding-left: 2px;
                      padding-right: 2px;
                    ">{{
                      page?.qa?.getQuestionAllNumber() - page?.qa?.getQuestionNumber()
                    }}</span>問
                </div>
              </div>
              <div class="interview_header__progress_bar">
                <div style="position: relative; height: 12px">
                  <progress style="position: absolute; top: 0" :value="progresspct" max="100"></progress>
                </div>
              </div>
            </div>
            <div class="interview_header__extitle" v-if="page?.qa?.getExpectationTitle().length > 0">
              「{{ page?.qa?.getExpectationTitle() }}」に関する質問
            </div>
            <div class="interview_header__title">
              {{ page?.qa?.getQuestionTitle() }}
              <span v-if="page.qa?.isMultiSelect()">（複数選択可）</span>
            </div>
            <div class="interview_header__description">
              {{ page?.qa?.getQuestionDescription() }}
            </div>
          </div>
          <div class="interview_body" v-show="page?.qa?.getQuestionNumber()">
            <div v-if="page?.qa?.getPhase() != 'payperuse'" class="">
              <template v-for="(item, index) in page?.qa?.getAnswers()" :key="index">
                <div>
                  <h2 v-if="!page.qa.isMultiSelect()" class="qasinglebtn" v-on:click="page.select(item.id)" :class="[
                    isSelected(item.id) ? 'qasinglebtn--selected' : '',
                    index == 0 ? 'qasinglebtn--first' : '',
                  ]">
                    <div>
                      {{ item.title }}
                    </div>
                    <div class="qasinglebtn__description" v-if="item.description.length > 0">
                      {{ item.description }}
                    </div>
                  </h2>

                  <h2 v-if="page.qa.isMultiSelect()" v-on:click="page.select(item.id)" class="qamultibtn" :class="[
                    isSelected(item.id) ? 'qamultibtn--selected' : '',
                    index == 0 ? 'qamultibtn--first' : '',
                  ]" style="position: relative; padding-left: 36px">
                    <div>
                      {{ item.title }}
                    </div>
                    <div class="qamultibtn__description" v-if="item.description.length > 0">
                      {{ item.description }}
                    </div>
                    <p class="qamultibtn__description" v-if="false"></p>
                    <img v-if="!isSelected(item.id)" style="position: absolute; top: 18px; left: 8px" width="20"
                      height="20" src="@/assets/check_outlined.svg" />
                    <img v-if="isSelected(item.id)" style="position: absolute; top: 18px; left: 8px" width="20"
                      height="20" src="@/assets/check_filled.svg" />
                  </h2>
                </div>
              </template>
            </div>
            <div v-if="page?.qa?.getPhase() == 'payperuse'" class="">
              <div class="amount">
                <div class="amount__left"></div>
                <div>
                  <input class="amount__input" v-model="input_amount" placeholder="半角数字で入力" type="number" />
                </div>
                <div class="amount__unit" v-if="page?.qa?.getAnswers().length > 0">
                  {{ page?.qa?.getAnswers()[0].unit }}
                </div>
              </div>
            </div>
            <div class="interview_skip" style="margin-top: 16px">
              <button class="interview_skip__btn" v-on:click="page.skip()" v-if="page.getPhase() != 'questionnaire'">
                スキップ
              </button>
            </div>
          </div>
          <div class="interview_control" v-show="page?.qa?.getQuestionNumber()">
            <button class="interview_control__back btn_outline_primary" v-on:click="back()">
              前の質問に戻る
            </button>
            <button class="interview_control__next btn_primary" v-if="page?.qa?.getPhase() != 'payperuse'"
              :class="[!page.isSelected() ? 'btn_primary--disabled' : '']" v-on:click="page.reply()">
              次へ
            </button>
            <button class="interview_control__next btn_primary" v-if="page?.qa?.getPhase() == 'payperuse'"
              :class="[!isActiveAmount() ? 'btn_primary--disabled' : '']" v-on:click="amountreply()">
              次へ
            </button>
          </div>
        </div>
        <div class="interview_contents__right"></div>
      </div>
    </transition>
    <div class="qaloading" v-show="page.qaLoading == true">
      <div class="qaloading__container">
        <div id="lottie"></div>
      </div>
    </div>

    <div class="diagnloading" v-if="diagnosisStatus > 0">
      <div class="diagnloading__box">
        <div class="diagnloading__mark">
          <div class="diagnloading__icon">
            <img src="@/assets/rmark.svg" width="132" height="132" />
          </div>
        </div>
        <div class="diagnloading__title" v-if="diagnosisStatus == 1">結果を作成中...</div>
        <div class="diagnloading__title" v-if="diagnosisStatus == 2">回答お疲れさまでした</div>
        <div class="diagnloading__btn" v-if="diagnosisStatus == 2"><button class="btn_primary" style="width: 100%"
            v-on:click="diagnosis()">診断結果を作成</button></div>
        <div class="diagnloading__title_link" v-if="diagnosisStatus == 2" v-on:click="gotolastqa()">最後の質問に戻る</div>
      </div>

    </div>
    <div v-if="!page.isProgress && pager.isDebug" style="background: rgb(239, 240, 240)">
      <div>デバグ</div>
      <div v-if="page.qa != null">
        <div>マルチセレクト：{{ page.qa.isMultiSelect() }}</div>
        <div>
          {{ page.qa.getQuestionNumber() }} /
          {{ page.qa.getQuestionAllNumber() }}
        </div>
        <div>
          {{ page.qa.getQuestionTitle() }}
        </div>
        <template v-for="(item, index) in page.qa.getAnswers()" :key="index">
          <div>
            <button v-on:click="page.reply(page.qa.getQuestionId(), [item.id])">
              {{ item.title }}
            </button>
          </div>
        </template>
        <div v-if="page.qa != null">
          <div>
            <template v-for="(item, index) in page.qa.getHistory()" :key="index">
              <div>
                <div>{{ index + 1 }}</div>
                <div>{{ item.getTitle() }}</div>
                <template v-for="(ritem, rindex) in item.getReplyTitles()" :key="rindex">
                  <div>{{ ritem }}</div>
                </template>
              </div>
            </template>
          </div>
          <div>
            {{ page.qa }}
          </div>
        </div>
      </div>
      <div>
        <input type="text" v-model="testdata" />
        <button v-on:click="inptest">test</button>
      </div>
    </div>
  </main>
</template>

<style scoped>
#lottie {
  margin: auto;
  width: 150px;
}
</style>

<style scoped>
.qaloading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 100;
}

.qaloading__container {
  padding-top: 200px;
}
</style>

<style scoped>
.qa__answer_title {
  margin-top: 4px;
}
</style>

<style scoped>
.diagnloading__icon {
  width: fit-content;
  margin: auto;
}

.diagnloading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 100;
}

.diagnloading__box {
  width: 320px;
  margin: auto;
  margin-top: 200px;
}

.diagnloading__title {
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
}

.diagnloading__title {
  font-size: 14px;
  line-height: 142%;
  color: #00AEAA;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
}

.diagnloading__title_link {
  text-align: center;
  margin-top: 24px;
  padding: 8px;
  padding-bottom: 12px;
  font-size: 14px;
  line-height: 142%;
  color: #00AEAA;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  cursor: pointer;
}

.diagnloading__title_link:hover {
  color: #00C9C9;
}

#lottie {
  margin: auto;
  width: 150px;
}
</style>

<style scoped>
.amount {
  display: flex;
}

.amount__left {
  margin: auto;
}

input::placeholder {
  font-size: 14px;
}

.amount__unit {
  padding-top: 8px;
  padding-left: 8px;
}

.amount__input {
  width: 138px;
  border-radius: 4px;
  padding: 10px;
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  border: 1px solid #636464;
}
</style>

<style scoped>
.interview_header__extitle {
  font-weight: 400;
  font-size: 13px;
  line-height: 132%;
  color: #636464;
}
</style>

<style scoped>
progress[value]::-webkit-progress-value {
  transition: width 0.5s;
}
</style>

<style scoped>
.vshow-enter-active,
.vshow-leave-active {
  transition: opacity 1s;
}

.vshow-enter,
vshow-leave-to {
  opacity: 0;
}

.vif-enter-active,
.vif-leave-active {
  transition: opacity 2s;
}

.vif-enter,
vif-leave-to {
  opacity: 0;
}
</style>

<style scoped>
progress {
  width: 100%;
  height: 6px;
  border-radius: 2px;
}

progress::-webkit-progress-bar {
  background-color: #e2e3e3;
  border-radius: 15px;
}

progress::-webkit-progress-value {
  background: rgb(255, 107, 74);
  border-radius: 15px;
}

progress::-moz-progress-bar {
  border-radius: 15px;
  background-color: #e2e3e3;
}

progress::-ms-fill {
  background: rgb(255, 107, 74);
  border-radius: 15px;
}
</style>
<style scoped>
.qasinglebtn {
  background: #f9fbfb;
  color: #444545;
  padding: 12px 12px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  width: calc(100% - 24px);
  /* max-width: 600px; */
  text-align: left;
  cursor: pointer;
}

.qasinglebtn--first {
  margin-top: 0px;
}

.qasinglebtn:hover {
  border: 2px solid #00c9c9;
}

.qasinglebtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}

.qamultibtn {
  background: #f9fbfb;
  color: #444545;
  padding: 18px 18px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  cursor: pointer;
}

.qamultibtn--first {
  margin-top: 0px;
}

.qamultibtn:hover {
  border: 2px solid #00c9c9;
}

.qamultibtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}

.qamultibtn__description {
  font-weight: 400;
  font-size: 12px;
  line-height: 126%;
  margin-top: 2px;
  color: #636464;
}

.qasinglebtn__description {
  font-weight: 400;
  font-size: 12px;
  line-height: 126%;
  margin-top: 2px;
  color: #636464;
}

.interview_header__progress_bar {
  margin-top: 12px;
}
</style>
<script>
// @ is an alias to /src

import tacklebox from "tacklebox";

import { InterviewPage } from "@/js/page/InterviewPage.js";

/* global bodymovin */

tacklebox.d("a");

export default {
  name: "InterviewView",
  data() {
    const self = this;
    return {
      testdata: "test",
      progresspct: 0,
      page: new InterviewPage(function () {
        // self.progresspct = 100;
        setTimeout(function () {
          self.diagnosisStatus = 2
        }, 600);
      }),
      input_amount: "",
      diagnosisStatus: 0,
    };
  },
  mounted() {
    const self = this;
    this.page.interviewId = this.$route.params.id;
    this.pager.changePage(this.page);
    this.page.onReEntryCallback = function () {
      self.$router.push({
        name: "expectation",
        params: { id: self.page.interviewId },
      });
    };
    bodymovin.loadAnimation({
      container: document.getElementById("lottie"),
      renderer: "svg", // 描画形式
      loop: true, // trueにしたらループ。1回再生の場合はfalse
      autoplay: true, // 自動再生
      path: "freeloading.json", // jsonのパスを指定
      name: "Hello World", // 今後のリファレンスとして名前を指定（オプション）
    });

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 ";
  },
  beforeMount() {
    //
  },
  watch: {
    "page.isProgress": function (oldv, newv) {
      const self = this;
      console.log(oldv, newv);
      if (newv) {
        console.log(this.progresspctbeforecalc());
        console.log(this.progresspctcalc());
        setTimeout(function () {
          if (self.progresspctcalc() != 0) {
            self.progresspct = self.progresspctcalc();
          } else {
            self.progresspct = 100;
          }
        }, 300);
      }
    },
  },
  methods: {
    gotolastqa() {
      this.diagnosisStatus = 0;
      this.back();
    },
    diagnosis() {
      const self = this;
      this.$router.push({
        name: "report",
        params: { id: self.page.interviewId },
      });
    },
    amountreply() {
      this.page.amountreply(this.input_amount);
      this.input_amount = "";
    },
    entrydelete(id) {
      if (window.confirm("回答履歴は消えます")) {
        const self = this;
        console.log(id);
        fetch(
          process.env.VUE_APP_HACHIWARE +
          "/interviews/" +
          this.page.interviewId +
          "/histories/" +
          id,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            // body: JSON.stringify(rbody)
          }
        )
          .then((response) => response.json())
          .then((json) => {
            console.log(json);
            self.$router.push({
              name: "expectation",
              params: { id: self.page.interviewId },
            });
          })
          .catch((error) => {
            tacklebox.e(error);
          });
      }
    },
    qadelete(id) {
      const self = this;
      console.log(id);
      fetch(
        process.env.VUE_APP_HACHIWARE +
        "/interviews/" +
        this.page.interviewId +
        "/histories/" +
        id,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          // body: JSON.stringify(rbody)
        }
      )
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          self.page.loadQa();
        })
        .catch((error) => {
          tacklebox.e(error);
        });
    },
    inptest() {
      console.log("test", this.testdata);
      fetch(
        process.env.VUE_APP_HACHIWARE +
        "/interviews/" +
        this.page.interviewId +
        "/histories/" +
        this.testdata,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          // body: JSON.stringify(rbody)
        }
      )
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          self.page.loadQa();
        })
        .catch((error) => {
          tacklebox.e(error);
        });
    },
    progresspctcalc() {
      let all = this.page?.qa?.getQuestionAllNumber();
      if (all) {
        if (all > 0) {
          if (this.page?.qa?.getQuestionNumber() > 0) {
            return (
              (this.page?.qa?.getQuestionNumber() /
                this.page?.qa?.getQuestionAllNumber()) *
              100
            );
          }
        }
      }
      return 0;
    },
    progresspctbeforecalc() {
      let all = this.page?.qa?.getQuestionAllNumber();
      if (all) {
        if (all > 0) {
          if (this.page?.qa?.getQuestionNumber() > 1) {
            return (
              ((this.page?.qa?.getQuestionNumber() - 1) /
                this.page?.qa?.getQuestionAllNumber()) *
              100
            );
          }
        }
      }
      return 0;
    },
    getFirstAnswer() {
      let hs = this.page.qa?.getHistory();
      if (hs) {
        if (hs.length > 0) {
          //
          let res = "";
          let csv = "";
          let ts = hs[0].getReplyTitles();
          for (let i in ts) {
            res += csv + ts[i];
            csv = "／";
          }

          return res;
        }
      }
      return "";
    },
    makeAnswerStringByHistory(history) {
      let res = "";
      let csv = "";
      let ts = history.getReplyTitles();
      for (let i in ts) {
        res += csv + ts[i];
        csv = "／";
      }

      return res;
    },
    isSelected(id) {
      for (let i in this.page.selecteds) {
        if (this.page.selecteds[i] == id) {
          return true;
        }
      }
      return false;
    },
    back() {
      // this.$router.push("/");
      let hs = this.page.qa?.getHistory();
      if (hs) {
        if (hs.length == 1) {
          if (hs[0].raw.entry.type == "freeword") {
            if (window.confirm("回答履歴は消えます")) {
              this.$router.push({ name: "freeword" });
              return;
            }
          }
          if (hs[0].raw.entry.type == "category") {
            if (window.confirm("回答履歴は消えます")) {
              console.log(hs[0].raw.entry.category.id, hs[0].raw.entry.category.title);
              location.href = this.lpurl(
                hs[0].raw.entry.category.id,
                hs[0].raw.entry.category.title
              );
              return;
            }
          }
          if (hs[0].raw.entry.type == "keyword") {
            if (window.confirm("回答履歴は消えます")) {
              console.log(hs[0].raw.entry.category.id, hs[0].raw.entry.category.title);
              location.href = this.klpurl(
                hs[0].raw.entry.category.id,
                hs[0].raw.entry.category.title
              );

              return;
            }
          }
        }
      }
      this.page.cencel();
    },
    onClose() {
      if (window.confirm("診断を終了してよろしいですか？")) {
        this.$router.push("/");
      }
    },
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
    isActiveAmount() {
      if (this.input_amount != null) {
        try {
          let n = Number(this.input_amount);
          if (n > 0) {
            return true;
          }
        } catch (ex) {
          console.log(ex);
        }
      }
      return false;
    },
  },
  components: {},
  props: {
    pager: Object,
  },
};
</script>
